export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ13.0d5da9ed.mp3";